import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface GetAvailableDisplaysResponse {
  model: string
  name: string
  integration: boolean
  isDevice: boolean
  isBeta?: boolean
  isDrone?: boolean
  category: string
}

export async function getAvailableDisplays(config?: AxiosRequestConfig) {
  const { data } = await companiesApi.get<{
    displays: GetAvailableDisplaysResponse[]
  }>(apiRoutes.listDisplays, config)

  return data.displays
}
